import { createAsyncThunk } from '@reduxjs/toolkit';
import { NETSUITE_ACTIONS } from 'store/netsuite/netsuite.constants';
import ApiClient from 'lib/api/ApiClient';

const isV2 = false;
const token = true;
const client = new ApiClient() as any;

const getNetSuiteMasterProjectsRequest = createAsyncThunk(
  NETSUITE_ACTIONS.getNetSuiteMasterProjectsRequest,
  async () => {
    const data = {};
    return await client.get(
      '/integrations/splashlight/netsuite_master_projects',
      {
        data,
        isV2,
        token
      }
    );
  }
);

export { getNetSuiteMasterProjectsRequest };
